/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ProductDetailsDisplay } from '@/components/blocks/ProductDetails/Display';
import { ProductDetailsPromos } from '@/components/blocks/ProductDetails/Promos';
import { ProductDetailsRibbonChips } from '@/components/blocks/ProductDetails/RibbonChips';
import { useProductDetails } from '@/data/Content/ProductDetails';
import { useLocalization } from '@/data/Localization';
import { ContentProvider } from '@/data/context/content';
import { useStoreLocatorState } from '@/data/state/useStoreLocatorState';
import { ID } from '@/data/types/Basic';
import { Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { FC, useEffect, useMemo, useState } from 'react';
import { ReleaseDateFormat } from '@/utils/Date';
import { ProductDetailsPrice } from '@/components/blocks/ProductDetails/Price';
import PDPBazaarVoiceSummary from '@/components/blocks/PDPBazaarVoiceSummary';
import { PdpProductNameAndDetailsSX } from '../PdpProductNameAndDetailsRv/styles/container';

export const PdpPriceAndRibbonRv: FC<{
	id: ID;
}> = ({ id }) => {
	const {
		dimensions: { contentSpacing },
	} = useTheme();
	const storeLocatorState = useStoreLocatorState();
	const {storeLocator} = storeLocatorState;
	const [physicalStoreName, setPhysicalStoreName] = useState<string>('');
	const productDetails = useProductDetails({ partNumber: id.toString(), physicalStoreName });
	const { product, selection, productAttrValues } = productDetails;
	const  productDetailsNs  = useLocalization('productDetail');
	useEffect(() => {
		setPhysicalStoreName(storeLocator.selectedStore?.physicalStoreName ?? '');
	}, [storeLocator.selectedStore]);

	const releaseDate = useMemo(()=>productAttrValues.ITNL_ReleaseDate,[productAttrValues]);

	return selection && product?.partNumber ? (
		<ContentProvider value={{...productDetails, ...storeLocatorState}}>
			<Stack sx={PdpProductNameAndDetailsSX}>
				<Stack direction={{md: 'row'}} spacing={contentSpacing}>
					<Stack spacing={2} sx={{width:'-webkit-fill-available'}}>
						<ProductDetailsDisplay hidePartNumber={true} />
						<PDPBazaarVoiceSummary
								partNumber={product?.partNumber} 
								catentryId={product.id}
							/>
						<ProductDetailsPromos />
						<ProductDetailsRibbonChips />
						{product.type === 'bundle' ? null : (
							<Stack spacing={2}>
								<ProductDetailsPrice />
								{releaseDate && 
									<Typography color="#368632">{productDetailsNs.RELEASE_DATE.t()}{ReleaseDateFormat(releaseDate)}</Typography>
								}							
							</Stack>
						)}
					</Stack>
				</Stack>
			</Stack>
		</ContentProvider>
	) : null;
};
